import _extends from "@babel/runtime/helpers/esm/extends";
var _Favorites, _CartOutlined, _QuoteOutlined;
import React from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { CulturePickerNew } from '../../CulturePicker/CulturePickerNew';
import { Favorites } from '../../icons/Favorites';
import { NotificationDrop } from './NotificationDrop';
import { InsightsDrop } from './InsightsDrop';
import { CartOutlined } from '../../icons/CartOutlined';
import { Avatar } from './Avatar';
import Badge from '@mui/material/Badge';
import { useTranslate } from '@im/react-localization';
import Button from '@mui/material/Button';
import { QuoteOutlined } from '../../icons/QuoteOutlined';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function HeaderUserActions(props) {
  var AvatarProps = props.AvatarProps,
    NotificationProps = props.NotificationProps,
    cartItemsCount = props.cartItemsCount,
    closeInsightsDrop = props.closeInsightsDrop,
    _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid,
    disableCartIcon = props.disableCartIcon,
    hasInsightData = props.hasInsightData,
    insightsContent = props.insightsContent,
    onUserActionClick = props.onUserActionClick,
    page = props.page,
    quoteItemsCount = props.quoteItemsCount,
    setIsInsightsButtonClicked = props.setIsInsightsButtonClicked,
    setIsInsightsDropOpen = props.setIsInsightsDropOpen,
    showAvatar = props.showAvatar,
    showCartIcon = props.showCartIcon,
    showCulturePicker = props.showCulturePicker,
    showFavoritesIcon = props.showFavoritesIcon,
    showInsightsIcon = props.showInsightsIcon,
    showNotificationIcon = props.showNotificationIcon,
    showQuoteIcon = props.showQuoteIcon;
  var translate = useTranslate();
  return /*#__PURE__*/_jsxs(RootStack, {
    alignItems: "center",
    direction: "row",
    spacing: "0.571rem",
    "data-element": "RootStack",
    "data-component": "HeaderUserActions",
    "data-source-file": "HeaderUserActions.tsx",
    children: [/*#__PURE__*/_jsx(Stack, {
      alignContent: "right",
      direction: "row",
      "data-element": "Stack",
      "data-source-file": "HeaderUserActions.tsx",
      children: showCulturePicker && /*#__PURE__*/_jsx(CulturePickerNew, {
        MenuProps: {
          PaperProps: {
            sx: {
              '& .MuiList-root': {
                minWidth: '148px',
                padding: '8px 12px'
              },
              '& .MuiMenuItem-root': {
                fontSize: '14px',
                fontweight: '400px',
                lineHeight: '22px',
                padding: '8px'
              },
              borderRadius: '4px',
              boxShadow: '0px 2px 6px rgba(51, 51, 51, 0.15)'
            }
          },
          anchorOrigin: {
            horizontal: 'right',
            vertical: 'bottom'
          },
          transformOrigin: {
            horizontal: 'right',
            vertical: 'top'
          }
        }
      })
    }), showFavoritesIcon && /*#__PURE__*/_jsx(IconButton, {
      "aria-label": translate('Navigation.Favorites'),
      className: "iconButton",
      "data-testid": "".concat(testid, "-FavoriteBtn"),
      onClick: function onClick() {
        return onUserActionClick('favorite');
      },
      children: _Favorites || (_Favorites = /*#__PURE__*/_jsx(Favorites, {}))
    }), showInsightsIcon && /*#__PURE__*/_jsx(InsightsDrop, {
      closeDrop: closeInsightsDrop,
      hasInsightData: hasInsightData,
      insightDropContent: insightsContent,
      maxDropHeight: 260,
      page: page,
      setIsInsightsButtonClicked: setIsInsightsButtonClicked,
      setIsInsightsDropOpen: setIsInsightsDropOpen
    }), showCartIcon && /*#__PURE__*/_jsx(IconButton, {
      "aria-label": translate('Cart.Cart'),
      className: "iconButton",
      "data-testid": "".concat(testid, "-CartOutlinedBtn"),
      disabled: disableCartIcon,
      onClick: function onClick() {
        return onUserActionClick('cart');
      },
      children: /*#__PURE__*/_jsx(Badge, {
        badgeContent: cartItemsCount,
        color: "primary",
        children: _CartOutlined || (_CartOutlined = /*#__PURE__*/_jsx(CartOutlined, {}))
      })
    }), showQuoteIcon && /*#__PURE__*/_jsx(IconButton, {
      "aria-label": translate('quote.Quote'),
      className: "iconButton",
      "data-testid": "".concat(testid, "-quoteOutlinedBtn"),
      disabled: disableCartIcon,
      onClick: function onClick() {
        return onUserActionClick('view-quote');
      },
      children: /*#__PURE__*/_jsx(Badge, {
        badgeContent: quoteItemsCount,
        color: "primary",
        children: _QuoteOutlined || (_QuoteOutlined = /*#__PURE__*/_jsx(QuoteOutlined, {}))
      })
    }), showNotificationIcon && /*#__PURE__*/_jsx(NotificationDrop, _extends({}, NotificationProps, {
      "data-testid": testid
    })), showQuoteIcon && /*#__PURE__*/_jsx(BackToQuoteBtn, {
      "aria-label": translate('quote.Quote'),
      color: "secondary",
      "data-testid": "".concat(testid, "-viewQuoteBtn"),
      disabled: disableCartIcon,
      onClick: function onClick() {
        return onUserActionClick('view-quote');
      },
      size: "small",
      variant: "outlined",
      children: translate('QuoteDetails.Back_to_quote')
    }), showAvatar && /*#__PURE__*/_jsx(Avatar, _extends({}, AvatarProps, {
      "data-testid": testid
    }))]
  });
}
var RootStack = styled(Stack)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiBadge-anchorOriginTopRightRectangular.MuiBadge-badge': {
      borderRadius: '8px',
      fontSize: '10px',
      height: '16px',
      left: '7px',
      lineHeight: '14px',
      top: '-2px',
      width: '20px'
    },
    '& .iconButton': {
      '& .MuiSvgIcon-root': {
        fontSize: '24px'
      },
      '&:hover': {
        backgroundColor: theme.palette.grey[200]
      }
    }
  };
});
var BackToQuoteBtn = styled(Button)(function () {
  return {
    '&:hover': {
      background: '#175cd3',
      borderWidth: 0,
      outlineColor: '#175cd3'
    },
    background: '#1570ef',
    borderRadius: '32px',
    borderWidth: 0,
    color: '#ffffff',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: '600',
    marginLeft: '25px',
    marginRight: '15px',
    minHeight: '38px',
    minWidth: '122px',
    outline: '#1570ef solid 1px',
    padding: '8px 14px',
    textTransform: 'none'
  };
});